import { ReactComponent as CheckIcon } from 'assets/img/filter/check.svg';
import { ReactComponent as LoaderIcon } from '../img/IconLoader.svg';
import { ReactComponent as IconBack } from '../img/iconBackForward.svg';
import { ReactComponent as IconDone } from '../img/iconDone.svg';
import { Button } from 'ui/Button';
import { FC } from 'react';
import styles from './ActionButtons.module.scss';
import { Loader } from '@mantine/core';

interface ActionButtonsProps {
  onBack: () => void;
  onPrimaryAction: () => void;
  isLoading: boolean;
  primaryButtonText: string;
  primaryActionIcon?: 'check' | 'done';
}

export const ActionButtons: FC<ActionButtonsProps> = ({
  onBack,
  onPrimaryAction,
  isLoading,
  primaryButtonText,
}) => {
  const renderIcon = () => {
    if (isLoading) return <Loader size='xs' color='white' />;
    return <IconDone />;
  };

  return (
    <div className={styles.btnGroup}>
      <Button onClick={onBack} className={styles.btnBack} theme='outline'>
        <IconBack />
      </Button>
      <Button
        onClick={onPrimaryAction}
        className={styles.btn}
        disabled={isLoading}
        size='L'
        theme='filed'>
        <div className={styles.buttonContent}>
          {primaryButtonText} {renderIcon()}
        </div>
      </Button>
    </div>
  );
};
